import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const MoreDropdownMenu = styled.div`
  position: absolute;
  right: 30px;
  z-index: 9999999999999999;
  display: ${(props) => props.display ?? "none"};
  float: right;
  min-width: 70px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: 100%;
  margin-top: 0px !important;
`;

export const BreadCrumb = styled.h2`
  color: #767676;
  font-size: 12px;
  font-family: lato;
  text-transform: initial;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  margin-bottom: 0px;
`;

export const ActionButtonDiv = styled.div`
  text-align: right;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#15aee5")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  font-weight: normal;
  width: auto;
  padding: 3px 10px;
  font-size: 14px;
  font-family: lato;
`;

export const ProductTitle = styled.div`
  justify-self: auto;
  color: #0a4986;
  font-weight: bold !important;
  font-size: 16px;
  margin-bottom: 0px !important;
`;
